/**
 * The colour a mobile browser paints its own chrome with, per theme.
 *
 * Plain module, not the client component beside it: `app/layout.tsx` reads
 * these in its server-side `viewport` export, and every export of a
 * `'use client'` module becomes a client reference that a server component
 * cannot read the value of.
 *
 * These are the real page backgrounds (`--background` in `app/globals.css`).
 * They were previously a hardcoded white and near-black that no longer
 * matched either theme.
 */
export const THEME_COLOR = {
  light: 'hsl(225 20% 97%)',
  dark: 'hsl(232 27% 7%)',
} as const;
